import hello from 'hellojs';
import { v4 as uuid } from 'uuid';
import hint from '@/api/rest/hint';
import { getSignInAuth, getSignUpAuth } from '@/config/auth';
import { MismatchedOAuthError, MismatchedProviderError, ServerError } from './errors';
import throwClientError from './helpers/throwClientError';
export async function signInWithGoogle(expected) {
    const google = hello('google');
    await google.login({ scope: 'profile,email' });
    const { email: gmail } = await google.api('me');
    const email = gmail.toLowerCase();
    if (expected && email !== expected.toLowerCase()) {
        throw new MismatchedOAuthError();
    }
    const { access_token: token } = google.getAuthResponse();
    if (!token) {
        // this shouldn't happen
        throw new ServerError(new Error('Unable to connect to Google oAuth'));
    }
    return { email, token };
}
async function attemptSignIn({ email, token }) {
    const challenge = await getSignInAuth().signIn(email);
    return getSignInAuth().sendCustomChallengeAnswer(challenge, token);
}
async function attemptSignUpAndIn(google) {
    const { email: gmail } = google;
    const email = gmail.toLowerCase();
    await getSignUpAuth().signUp({
        username: email,
        password: uuid(),
        attributes: {
            email,
            'custom:provider:name': 'google',
        },
    });
    return attemptSignIn(google);
}
export default async function authoriseWithGoogle({ google: authorised, email: expected, promote, }) {
    try {
        const google = authorised || await signInWithGoogle(expected);
        const { email: gmail } = google;
        const email = gmail.toLowerCase();
        const { exists, provider } = await hint(email);
        if (!exists) {
            await attemptSignUpAndIn(google);
            return {};
        }
        if (provider !== 'google' && promote !== true) {
            throw new MismatchedProviderError('google');
        }
        await attemptSignIn(google);
        return {};
    }
    catch (error) {
        return throwClientError(error, { provider: 'google' });
    }
}
